/**
 * Changelog Data — was wir zuletzt gebaut haben.
 *
 * Schema (per Eintrag):
 *   id: stable unique ID
 *   date: ISO-Datum (YYYY-MM-DD)
 *   title: H3-Headline
 *   description: kurz prägnant (1-3 Sätze)
 *   category: 'belege' | 'rechnungen' | 'sb-portal' | 'mobile' | 'banking' | 'preise' | 'sonstiges'
 *   plan_filter?: ['free','basic','pro','lifetime']  // undefined = für alle
 *   link?: in-App-Link, optional
 *   badge?: 'Neu' | 'Verbessert' | 'Behoben'
 *
 * NEU oben hinzufügen. ID darf nicht geändert werden (User-Read-State persistiert auf der ID).
 */
const CHANGELOG = [
  // ──────────── RELEASE „beleg-eingang per e-mail" — 22.07.2026 ────────────
  {
    id: '2026-07-beleg-mail-adresse',
    date: '2026-07-22',
    title: 'NEU: Belege per E-Mail einreichen',
    description: 'Du hast jetzt eine persönliche Beleg-E-Mail-Adresse (z. B. max-a1b2@belege.ivoliq.io). Leite Rechnungen einfach dorthin weiter — oder hinterlege die Adresse direkt beim Lieferanten. Die KI erfasst alles automatisch, du bestätigst nur noch. Deine Adresse findest du unter Einstellungen → Unternehmen (Pro-Feature).',
    category: 'belege',
    badge: 'Neu',
    audience: 'fl',
    link: '/settings?tab=company',
  },
  {
    id: '2026-07-duplikat-workflow',
    date: '2026-07-22',
    title: 'Duplikate: vergleichen & entscheiden',
    description: 'Wird ein Beleg als mögliches Duplikat erkannt, zeigt dir der Beleg-Drawer jetzt beide Belege im direkten Vergleich. Du entscheidest per Klick: beide behalten oder einen davon deaktivieren — egal welchen.',
    category: 'belege',
    badge: 'Verbessert',
    audience: 'fl',
    link: '/finances',
  },
  // ──────────── RELEASE „migrationsassistent" — 24.06.2026 ────────────
  {
    id: '2026-06-umzugs-assistent',
    date: '2026-06-24',
    title: 'Umzugs-Assistent: in Minuten zu ivoliq',
    description: 'Hol deine Daten aus sevDesk, Lexware Office, DATEV & Co. geführt und GoBD-konform zu ivoliq — Kunden, Rechnungen und Belege werden geprüft übernommen. Zu finden unter Einstellungen → Umzug.',
    category: 'migration',
    badge: 'Neu',
    audience: 'fl',
    link: '/settings?tab=migration',
  },
  {
    id: '2026-06-at-ust-4-9',
    date: '2026-06-24',
    title: 'Österreich: neuer 4,9 %-Satz für Grundnahrungsmittel',
    description: 'Ab 1.7.2026 gilt in Österreich der neue ermäßigte Satz von 4,9 % für ausgewählte Grundnahrungsmittel (§ 10 Abs 1a UStG). Du kannst ihn in Rechnungen und Belegen auswählen — die UVA weist ihn automatisch korrekt aus (KZ 124).',
    category: 'steuern',
    badge: 'Neu',
    audience: 'fl',
  },
  {
    id: '2026-06-fl-beleg-vorschau-navigation',
    date: '2026-06-24',
    title: 'Beleg-Drawer mit Vorschau & Tastatur-Navigation',
    description: 'Beim Öffnen einer Eingangsrechnung siehst du den Beleg jetzt sofort als große Vorschau (Bild & PDF) links neben den Details. Mit ↑/↓ springst du durch die Liste, mit Enter speicherst du.',
    category: 'belege',
    badge: 'Verbessert',
    audience: 'fl',
    link: '/finances',
  },
  {
    id: '2026-06-fl-rc-auto',
    date: '2026-06-24',
    title: 'Reverse Charge wird automatisch erkannt',
    description: 'ivoliq liest die USt-IdNr. des Lieferanten aus dem Beleg und aktiviert Reverse Charge automatisch, wenn alle Voraussetzungen erfüllt sind (Lieferant im Ausland, 0 % USt, gültige UID) — die UID ist jetzt auch direkt im Beleg-Drawer sichtbar.',
    category: 'belege',
    badge: 'Neu',
    audience: 'fl',
  },
  {
    id: '2026-06-ausgabe-deaktivieren',
    date: '2026-06-24',
    title: 'Belege deaktivieren statt löschen',
    description: 'Doppelte oder fehlerhafte Belege werden nicht mehr gelöscht, sondern mit Begründung deaktiviert (GoBD-konform): Sie bleiben sichtbar, zählen aber nicht mehr in UVA, Gewinn, Periodenabschluss oder Export.',
    category: 'belege',
    badge: 'Verbessert',
  },
  // ──────────── GROSSES JUNI-RELEASE 2026 ────────────
  {
    id: '2026-06-sb-portal-remake',
    date: '2026-06-12',
    title: 'Das neue Steuerberater-Portal ist da',
    description: 'Komplettes Remake: geführter Onboarding-Workflow für deine Kanzlei, Mandanten direkt aus der Applikation anlegen und verwalten — und alles erreichbar unter der neuen Domain sb.ivoliq.io.',
    category: 'sb-portal',
    badge: 'Neu',
    audience: 'sb',
  },
  {
    id: '2026-06-fl-afa',
    date: '2026-06-12',
    title: 'AfA & Anlagevermögen',
    description: 'Wirtschaftsgüter mit einem Klick aus dem Beleg aktivieren — die Abschreibungen berechnet ivoliq automatisch.',
    category: 'belege',
    badge: 'Neu',
    audience: 'fl',
    link: '/anlagen',
  },
  {
    id: '2026-06-fl-vstp',
    date: '2026-06-12',
    title: 'Vorsteuerpauschalierung (Österreich)',
    description: 'Vorsteuer pauschal statt belegweise: ivoliq berechnet die Pauschale automatisch und weist sie direkt in der UVA aus.',
    category: 'steuern',
    badge: 'Neu',
    audience: 'fl',
  },
  {
    id: '2026-06-fl-wiederkehrende-ausgaben',
    date: '2026-06-12',
    title: 'Wiederkehrende Ausgaben einfach erfassen',
    description: 'Miete, Software-Abos & Co. einmal anlegen — ivoliq bucht sie automatisch im gewählten Intervall weiter.',
    category: 'belege',
    badge: 'Neu',
    audience: 'fl',
    link: '/finances',
  },
  // ──────────── Frühere Releases ────────────
  {
    id: '2026-06-sb-storno-korrektur',
    date: '2026-06-02',
    title: 'Storno- & Korrekturrechnungen im Mandanten-Detail',
    description: 'Stornos und Korrekturrechnungen deiner Mandanten werden jetzt im SB-Portal sauber ausgewiesen: eigene Badges in der Rechnungs-Tabelle, korrektes Vorzeichen bei der Brutto-Summe, Verweistexte („storniert Original" / „ersetzt frühere Rechnung") und der Korrekturgrund. Jede Storno-/Korrektur-Aktion landet automatisch im Audit-Log.',
    category: 'sb-portal',
    badge: 'Neu',
    audience: 'sb',
  },
  {
    id: '2026-06-sb-anlagen-tab',
    date: '2026-05-28',
    title: 'Anlagen-Tab mit AfA-Verwaltung & Anlagenspiegel',
    description: 'Im Mandanten-Detail findest du jetzt den Tab „Anlagen": Anlagenspiegel-PDF, Buchwert-Verlauf, § 15a-Korrekturen und AfA-Buchungen direkt in CSV/DATEV-Export. Mit aktiver Vollmacht kannst du Anlagen bearbeiten (Pflicht-Begründung + Audit-Log) und Perioden sperren.',
    category: 'sb-portal',
    badge: 'Neu',
    audience: 'sb',
  },
  {
    id: '2026-05-cross-border-detection',
    date: '2026-05-19',
    title: 'Cross-Border-Geschäfte werden automatisch erkannt',
    description: 'Wenn der Kunde im EU-Ausland oder Drittland sitzt, erkennt ivoliq das automatisch und du kannst beim Erstellen der Rechnung zwischen den drei DACH-Varianten wählen: Reverse Charge, innergemeinschaftliche Lieferung oder Drittland-Export. Der gesetzlich vorgeschriebene Pflichthinweis erscheint passend dazu automatisch auf der PDF — für Deutschland und Österreich mit den korrekten §-Verweisen.',
    category: 'rechnungen',
    badge: 'Neu',
    audience: 'fl',
  },
  {
    id: '2026-05-ai-multi-tax',
    date: '2026-05-15',
    title: 'Belege mit mehreren Steuersätzen werden automatisch korrekt verarbeitet',
    description: 'Restaurant-Belege mit 7% auf Speisen und 19% auf Getränke, Mixed-Hotel-Rechnungen oder Tank-Belege mit Zusatzartikeln werden von der KI automatisch in die einzelnen Steuersätze zerlegt und in DATEV- und GoBD-Exporten zeilenweise dokumentiert.',
    category: 'belege',
    badge: 'Neu',
  },
  {
    id: '2026-05-fx-conversion',
    date: '2026-05-15',
    title: 'Auslandsbelege automatisch zum Tageskurs in Euro umgerechnet',
    description: 'Belege in USD, GBP, CHF oder jeder anderen Währung werden mit dem amtlichen Tageskurs (Frankfurter-API) in Euro umgerechnet. Wechselkurs und Kurs-Stichtag werden im Beleg gespeichert — perfekt für DATEV-Export und UStVA-Buchung.',
    category: 'belege',
    badge: 'Neu',
  },
];

export const CATEGORY_LABELS = {
  belege: 'Belege',
  rechnungen: 'Rechnungen',
  steuern: 'Steuern',
  migration: 'Umzug',
  'sb-portal': 'Steuerberater-Portal',
  mobile: 'Mobile',
  banking: 'Banking',
  preise: 'Preise',
  sonstiges: 'Sonstiges',
};

export const BADGE_STYLES = {
  Neu: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  Verbessert: 'bg-blue-100 text-blue-700 border-blue-200',
  Behoben: 'bg-amber-100 text-amber-700 border-amber-200',
};

export default CHANGELOG;
